// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"fdd708442b22dd0b68ff","453":"a6ac5ecbaf6e0b66c1dc"}[chunkId] + ".js";
};